export const calculateScores = (answers) => {
  const categoryScores = {
    marketStrategy: 0,
    productMarketFit: 0,
    salesProcess: 0,
    marketingChannels: 0,
    customerSuccess: 0,
    teamResources: 0,
  }

  const categoryQuestionCounts = {
    marketStrategy: 0,
    productMarketFit: 0,
    salesProcess: 0,
    marketingChannels: 0,
    customerSuccess: 0,
    teamResources: 0,
  }

  // Process each answer
  Object.entries(answers).forEach(([questionId, answer]) => {
    const category = getCategoryFromQuestionId(questionId)
    if (category && answer && answer.score !== undefined) {
      categoryScores[category] += answer.score
      categoryQuestionCounts[category]++
    }
  })

  // Calculate average scores for each category
  const finalScores = {}
  Object.keys(categoryScores).forEach((category) => {
    if (categoryQuestionCounts[category] > 0) {
      finalScores[category] = Math.round(categoryScores[category] / categoryQuestionCounts[category])
    } else {
      finalScores[category] = 0
    }
  })

  return finalScores
}

const getCategoryFromQuestionId = (questionId) => {
  if (questionId.includes("market_strategy")) return "marketStrategy"
  if (questionId.includes("product_market_fit")) return "productMarketFit"
  if (questionId.includes("sales_process")) return "salesProcess"
  if (questionId.includes("marketing_channels")) return "marketingChannels"
  if (questionId.includes("customer_success")) return "customerSuccess"
  if (questionId.includes("team_resources")) return "teamResources"
  return null
}
